import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconTalkingPoints = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 30 30"
    data-fill-none
  >
    <rect
      x="3"
      y="3"
      width="24"
      height="24"
      rx="4"
      fill="#28354D"
    />
    <path
      d="M15.5273 9H7.00162"
      stroke="white"
      strokeWidth="1.77692"
      strokeLinecap="round"
    />
    <path
      d="M24 13L7 13"
      stroke="white"
      strokeWidth="1.77692"
      strokeLinecap="round"
    />
    <path
      d="M24 21H7"
      stroke="white"
      strokeWidth="1.77692"
      strokeLinecap="round"
    />
    <path
      d="M24 17H7"
      stroke="white"
      strokeWidth="1.77692"
      strokeLinecap="round"
    />
  </SvgIcon>
));
IconTalkingPoints.displayName = 'IconTalkingPoints';
